<template>
  <div class="mt-6">
    <Pagination
      v-model="page"
      :per-page="hitsPerPage || 0"
      :records="nbHits || 0"
      :options="{
        template: shallowRef(CustomPagination),
        edgeNavigation: false,
        chunksNavigation: 'scroll',
        chunk: 3,
        hideCount: true,
      }"
      @paginate="paginate"
    ></Pagination>
  </div>
</template>

<script lang="ts" setup>
import Pagination from 'v-pagination-3'
import { useRouteQuery } from '@vueuse/router'
import CustomPagination from '../common/CustomPagination.vue'

const { nbHits, hitsPerPage } = defineProps<{
  hitsPerPage?: number
  nbHits?: number
  nbPages?: number
}>()
const emit = defineEmits(['updated'])

const pageQuery = useRouteQuery('page')

const page = ref(Number(pageQuery.value) || 1)

watch(
  () => pageQuery.value,
  (value) => {
    page.value = Number(value) || 1
  }
)

function paginate(page: number) {
  emit('updated', page)
}
</script>
<style scoped></style>
